import { type ArpeggioSelection, arpeggioLabel } from '@theory/arpeggios';
import type { ScaleId } from '@theory/scales';
import styles from './ArpeggioButton.module.css';

interface ArpeggioButtonProps {
  selection: ArpeggioSelection;
  scaleRootNote: string | null;
  scaleId: ScaleId | null;
  onPress: () => void;
}

export function ArpeggioButton({
  selection,
  scaleRootNote,
  scaleId,
  onPress,
}: ArpeggioButtonProps) {
  const isActive = selection !== null;
  const label = isActive ? arpeggioLabel(selection, scaleRootNote, scaleId) : '';
  const a11yLabel = isActive
    ? `Arpeggio overlay: ${label}. Tap to change.`
    : 'Arpeggio overlay: none. Tap to choose an arpeggio.';

  return (
    <button
      type="button"
      className={[styles.btn, isActive && styles.active].filter(Boolean).join(' ')}
      onClick={onPress}
      aria-label={a11yLabel}
      aria-pressed={isActive}
    >
      <svg
        className={styles.icon}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        aria-hidden
      >
        <circle cx="8" cy="8" r="6.5" />
        <circle cx="6" cy="10.5" r="1.4" fill="currentColor" stroke="none" />
        <line x1="7.4" y1="10.5" x2="7.4" y2="5.2" />
        <path d="M7.4 5.2 L11 6.2" />
      </svg>
      {isActive && <span className={styles.label}>{label}</span>}
    </button>
  );
}
